import {calculateScrollPercentage} from './calculate-scroll-percentage';

export interface IScrollState {
  scrollLeft: number;
  maxScrollLeft: number;
  percentage: number;
  isScrollable: boolean;
}

export const createScrollState = (
    scrollLeft: number,
    scrollWidth: number,
    clientWidth: number,
): IScrollState => {
    const normalizedScrollLeft = Math.max(0, scrollLeft);
    const maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
    const percentage = calculateScrollPercentage(normalizedScrollLeft, maxScrollLeft);

    return {
        scrollLeft: normalizedScrollLeft,
        maxScrollLeft,
        percentage,
        isScrollable: maxScrollLeft > 0,
    };
};
